import React from 'react';
import {
  LiveBetsContainer,
  TranslationKeys,
  userInfoStore,
  useTranslation,
} from '@pascal/pascal-core';
import { observer } from 'mobx-react-lite';
import { LiveBetsItems } from './liveBetsItem';
import { OtherBets } from './otherbets';

export const LiveBetsWrapper = observer(() => {
  const t = useTranslation();

  const { currencySymbolOrCode } = userInfoStore;

  const { BetType, PlayerId, Win, Bet } = TranslationKeys;
  return (
    <LiveBetsContainer
      renderMyLiveBetItem={(data, index, list) => {
        return <LiveBetsItems data={data || []} index={index} list={list} key={data?.id} t={t} />;
      }}
      renderOtherLiveBetItem={(data, index, list) => {
        return <OtherBets data={data || []} index={index} list={list} key={data?.id} />;
      }}
      headerNames={[
        { name: `${t(PlayerId)}` },
        { name: `${t(BetType)}` },
        { name: `${t(Bet)}  (${currencySymbolOrCode})` },
        { name: `${t(Win)} (${currencySymbolOrCode})` },
      ]}
    />
  );
});
